export const DEMOGRAPHICS = "DEMOGRAPHICS";
export const LANGUAGES_OBJECTIVES = "LANGUAGES_OBJECTIVES";

export const StepsFlags = new Map();
StepsFlags.set(DEMOGRAPHICS, "demographics_added");
StepsFlags.set(LANGUAGES_OBJECTIVES, "learning_objectives_added");

export const FlagsUserInfoStrings: string[] = [
  ...StepsFlags.values(),
] as string[];
